/* Sensory PDP buybox + gallery behavior. Scoped per .cn-pdp root. */
(() => {
  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD',
      }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2);
    }
  };

  document.querySelectorAll('.cn-pdp').forEach((root) => {
    const currency = root.dataset.currency || 'USD';
    let variants = [];
    try {
      variants = JSON.parse(root.dataset.variants || '[]');
    } catch (e) {
      variants = [];
    }

    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const variantInput = root.querySelector('[data-variant-id]');
    const submit = root.querySelector('[data-submit]');
    const submitLabel = root.querySelector('[data-submit-label]');
    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare]');
    const saveEl = root.querySelector('[data-save]');
    const colorNameEl = root.querySelector('[data-selected-color]');
    const sizeNameEl = root.querySelector('[data-selected-size]');
    const stickyBar = root.querySelector('[data-sticky-bar]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const stickyCompare = root.querySelector('[data-sticky-compare]');
    const stickyLabel = root.querySelector('[data-sticky-label]');
    const stickyCta = root.querySelector('[data-sticky-cta]');

    const optionButtons = Array.from(
      root.querySelectorAll('.swatch-item[data-option-position], .v-size[data-option-position], .cn-size-chip[data-option-position]')
    );

    const readSelection = () => {
      const selected = {};
      ['.swatch-item.active', '.v-size.active'].forEach((scope) => {
        root.querySelectorAll(scope).forEach((btn) => {
          selected[btn.dataset.optionPosition] = btn.dataset.optionValue;
        });
      });
      // Drawer chips mirror the buybox size selection.
      root.querySelectorAll('.cn-size-chip.active').forEach((btn) => {
        selected[btn.dataset.optionPosition] = btn.dataset.optionValue;
      });
      return selected;
    };

    const findVariant = (selected) => {
      return (
        variants.find((variant) =>
          (variant.options || []).every((value, index) => {
            const wanted = selected[String(index + 1)];
            return !wanted || value === wanted;
          })
        ) || null
      );
    };

    const paintOptionButtons = (selected) => {
      optionButtons.forEach((btn) => {
        const isActive = selected[btn.dataset.optionPosition] === btn.dataset.optionValue;
        btn.classList.toggle('active', isActive);
        if (btn.getAttribute('role') === 'radio') btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });
    };

    const paintVariant = (variant) => {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      const priceText = money(variant.price, currency);
      if (priceEl) priceEl.textContent = priceText;
      if (stickyPrice) stickyPrice.textContent = priceText;
      const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        if (hasCompare) {
          compareEl.textContent = money(variant.compare_at_price, currency);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (saveEl) {
        if (hasCompare) {
          saveEl.textContent = 'Save ' + money(variant.compare_at_price - variant.price, currency);
          saveEl.style.display = '';
        } else {
          saveEl.style.display = 'none';
        }
      }
      if (stickyCompare) {
        if (hasCompare) {
          stickyCompare.textContent = money(variant.compare_at_price, currency);
          stickyCompare.style.display = '';
        } else {
          stickyCompare.style.display = 'none';
        }
      }
      const label = variant.available ? 'Add to cart — ' + priceText : 'Sold out';
      if (submit) submit.disabled = !variant.available;
      if (submitLabel) submitLabel.textContent = label;
      if (stickyLabel) stickyLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (stickyCta) stickyCta.disabled = !variant.available;
    };

    const syncFromSelection = () => {
      const selected = readSelection();
      const colorBtn = root.querySelector('.swatch-item.active');
      const sizeBtn = root.querySelector('.v-size.active, .cn-size-chip.active');
      if (colorNameEl && colorBtn) colorNameEl.textContent = colorBtn.dataset.optionValue;
      if (sizeNameEl && sizeBtn) sizeNameEl.textContent = sizeBtn.dataset.optionValue;
      paintOptionButtons(selected);
      paintVariant(findVariant(selected));
    };

    optionButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        // Deactivate siblings sharing the same option position, then activate.
        optionButtons.forEach((other) => {
          if (other.dataset.optionPosition === btn.dataset.optionPosition) other.classList.remove('active');
        });
        btn.classList.add('active');
        syncFromSelection();
      });
    });

    /* Tabs */
    const tabList = root.querySelector('[data-tabs]');
    const tabCard = root.querySelector('[data-tab-card]');
    if (tabList && tabCard) {
      const tabs = Array.from(tabList.querySelectorAll('[role="tab"]'));
      const panes = Array.from(tabCard.querySelectorAll('[role="tabpanel"]'));
      const activate = (index, focus) => {
        tabs.forEach((tab, i) => {
          const active = i === index;
          tab.classList.toggle('active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
          if (active) tabCard.dataset.activeColor = tab.dataset.color || 'blue';
        });
        panes.forEach((pane, i) => pane.classList.toggle('active', i === index));
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(i, false));
        tab.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const next = event.key === 'ArrowRight' ? (i + 1) % tabs.length : (i - 1 + tabs.length) % tabs.length;
            activate(next, true);
          }
        });
      });
    }

    /* Size drawer */
    const overlay = root.querySelector('[data-size-overlay]');
    const drawer = root.querySelector('[data-size-drawer]');
    let lastFocus = null;
    const setDrawer = (open) => {
      if (!overlay) return;
      overlay.classList.toggle('open', open);
      overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) {
        lastFocus = document.activeElement;
        if (drawer) drawer.focus();
      } else if (lastFocus && lastFocus.focus) {
        lastFocus.focus();
      }
    };
    root.querySelectorAll('[data-size-guide-trigger]').forEach((btn) => {
      btn.addEventListener('click', () => setDrawer(true));
    });
    const closeBtn = root.querySelector('[data-size-close]');
    if (closeBtn) closeBtn.addEventListener('click', () => setDrawer(false));
    if (overlay) {
      overlay.addEventListener('click', (event) => {
        if (event.target === overlay) setDrawer(false);
      });
    }
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setDrawer(false);
        closeLightbox();
      }
    });

    /* Lightbox (product.media only) */
    const lightbox = root.querySelector('[data-lightbox-overlay]');
    const lightboxImg = root.querySelector('[data-lightbox-image]');
    const lightboxSources = Array.from(root.querySelectorAll('[data-lightbox]')).map((btn) => btn.dataset.full || (btn.querySelector('img') && btn.querySelector('img').src));
    let lightboxIndex = 0;
    const showLightbox = (index) => {
      if (!lightbox || !lightboxImg || !lightboxSources.length) return;
      lightboxIndex = (index + lightboxSources.length) % lightboxSources.length;
      lightboxImg.src = lightboxSources[lightboxIndex];
      lightboxImg.onload = () => {
        if (lightboxImg.naturalWidth) lightboxImg.width = lightboxImg.naturalWidth;
        if (lightboxImg.naturalHeight) lightboxImg.height = lightboxImg.naturalHeight;
      };
      lightbox.classList.add('active');
      document.documentElement.style.overflow = 'hidden';
      lightbox.focus();
    };
    const openLightbox = (src) => {
      const index = lightboxSources.indexOf(src);
      showLightbox(index >= 0 ? index : 0);
    };
    const closeLightbox = () => {
      if (!lightbox || !lightbox.classList.contains('active')) return;
      lightbox.classList.remove('active');
      document.documentElement.style.overflow = '';
      if (lightboxImg) lightboxImg.removeAttribute('src');
    };
    root.querySelectorAll('[data-lightbox]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const full = btn.dataset.full || (btn.querySelector('img') && btn.querySelector('img').src);
        openLightbox(full);
      });
    });
    if (lightbox) {
      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox) closeLightbox();
      });
      const lightboxClose = root.querySelector('[data-lightbox-close]');
      if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
      const lightboxPrev = root.querySelector('[data-lightbox-prev]');
      const lightboxNext = root.querySelector('[data-lightbox-next]');
      if (lightboxPrev) lightboxPrev.addEventListener('click', (event) => { event.stopPropagation(); showLightbox(lightboxIndex - 1); });
      if (lightboxNext) lightboxNext.addEventListener('click', (event) => { event.stopPropagation(); showLightbox(lightboxIndex + 1); });
      lightbox.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') showLightbox(lightboxIndex + 1);
        if (event.key === 'ArrowLeft') showLightbox(lightboxIndex - 1);
      });
    }

    /* Mobile peek dots */
    const peekTrack = root.querySelector('[data-peek-track]');
    const dotsWrap = root.querySelector('[data-gallery-dots]');
    if (peekTrack && dotsWrap) {
      const dots = Array.from(dotsWrap.querySelectorAll('.gallery-dot'));
      const slides = Array.from(peekTrack.children);
      const syncDots = () => {
        const index = Math.max(0, Math.min(slides.length - 1, Math.round(peekTrack.scrollLeft / Math.max(1, peekTrack.clientWidth))));
        dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
      };
      let ticking = false;
      peekTrack.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          syncDots();
          ticking = false;
        });
      }, { passive: true });
      window.addEventListener('resize', syncDots);
      syncDots();
    }

    /* Tactile carousel (mobile) */
    const tactileTrack = root.querySelector('[data-tactile-track]');
    const tactilePrev = root.querySelector('[data-tactile-prev]');
    const tactileNext = root.querySelector('[data-tactile-next]');
    const tactileProgress = root.querySelector('[data-tactile-progress]');
    if (tactileTrack && tactilePrev && tactileNext) {
      const cards = Array.from(tactileTrack.querySelectorAll('article'));
      let tactileIndex = 0;
      const onlyMobile = window.matchMedia('(max-width: 900px)');
      const syncTactile = () => {
        tactileIndex = Math.max(0, Math.min(cards.length - 1, Math.round(tactileTrack.scrollLeft / Math.max(1, tactileTrack.clientWidth))));
        tactilePrev.disabled = tactileIndex === 0;
        tactileNext.disabled = tactileIndex === cards.length - 1;
        if (tactileProgress) tactileProgress.textContent = tactileIndex + 1 + ' / ' + cards.length;
      };
      const goTactile = (index) => {
        if (!onlyMobile.matches) return;
        tactileIndex = Math.max(0, Math.min(cards.length - 1, index));
        tactileTrack.scrollTo({ left: tactileIndex * tactileTrack.clientWidth, behavior: 'smooth' });
      };
      tactilePrev.addEventListener('click', () => goTactile(tactileIndex - 1));
      tactileNext.addEventListener('click', () => goTactile(tactileIndex + 1));
      tactileTrack.addEventListener('scroll', () => requestAnimationFrame(syncTactile), { passive: true });
      window.addEventListener('resize', syncTactile);
      syncTactile();
    }

    /* Sticky bar: reveal once the main CTA scrolls out of view */
    if (stickyBar && submit) {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => stickyBar.classList.toggle('is-hidden', entry.isIntersecting));
          },
          { rootMargin: '0px' }
        );
        observer.observe(submit);
      } else {
        stickyBar.classList.remove('is-hidden');
      }
    }
    if (stickyCta && form) {
      stickyCta.addEventListener('click', () => {
        if (form.requestSubmit) form.requestSubmit(submit);
        else if (submit) submit.click();
      });
    }

    /* Add to cart via existing cart infrastructure */
    if (form) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!variantInput || !variantInput.value || (submit && submit.disabled)) return;
        if (submit) submit.disabled = true;
        const original = submitLabel ? submitLabel.textContent : '';
        if (submitLabel) submitLabel.textContent = 'Adding…';
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
          if (!response.ok) throw new Error('Cart add failed');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (submitLabel) submitLabel.textContent = 'Added';
          if (stickyLabel) stickyLabel.textContent = 'Added';
          window.setTimeout(() => syncFromSelection(), 1200);
        } catch (error) {
          if (submit) submit.disabled = false;
          if (submitLabel) submitLabel.textContent = original || 'Try again';
        }
      });
    }

    syncFromSelection();
  });
})();
